import React from 'react';
import './Logo.less';
import { ReactComponent as LogoIcon } from 'assets/images/logo.svg';
import clsx from 'clsx';
import { isCanada } from 'app/common/websiteCountry';

interface Props {
  className?: string;
}

export default function Logo({ className }: Props) {
  return (
    <span
      className={clsx('logo', className, {
        'logo_brand-bg': isCanada,
      })}
    >
      <LogoIcon className="logo-icon" />
    </span>
  );
}
